import React from "react";
import { useContext, useEffect, useState } from "react";
import Contexto from "../context/Contexto";
import Footer from "./Footer";
import Header from "./Header";
import Loader from "./Loader";
import "../assets/css/Layout.css";
//import Transicion from "./Transicion";
import { useNavigate } from "react-router-dom";

function Layout(props) {
  const [mandate, setMandate] = useState([]);

  const { isLoader, aDondeVoy, Griseado } = useContext(Contexto);
  const { children } = props;
  const navigate = useNavigate();

  useEffect(() => {
    // navigate(aDondeVoy);
    if (aDondeVoy !== null) {
      setMandate("todoGris");

      setTimeout(() => {
        navigate(aDondeVoy);
        setMandate("");
        Griseado(null);
      }, 500);
    } else {
      setMandate("");
    }
  }, [aDondeVoy]);

  return (
    <>
      {" "}
      {/* <Transicion></Transicion> */}
      {isLoader && <Loader></Loader>}
      <div className={` ${mandate}`}>
        <Header></Header>
        <div className="container ">{children}</div>
        <Footer></Footer>{" "}
      </div>
    </>
  );
}

export default Layout;
